
export const USER_TYPE_ABBREVIATIONS = {
  AUTHENTICATED_ACTIVE_SHARED_SERVICES_USER: 'ssu_a',
  AUTHENTICATED_INACTIVE_SHARED_SERVICES_USER: 'ssu_i',
  AUTHENTICATED_ACTIVE_LEGACY_USER: 'osu_a',
  AUTHENTICATED_INACTIVE_LEGACY_USER: 'osu_i',
  SHARED_SERVICES_USER: 'ssu',
  LEGACY_USER: 'osu'
};

export const ACCOUNT_STATUS = {
  ABCMOUSE: 'abcmouse',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NONE: 'none'
};
